import React from 'react';
import { SidebarItem } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import VersionIcon from '@material-ui/icons/LocalOffer';

/**
 * The version the app runs, at the bottom of the sidebar: the release tag, or
 * branch and commit for a build that is not a release. It opens the release
 * notes, the commit or the repository in GitLab. Without both in the config
 * there is nothing to show.
 */
export const SidebarVersion = () => {
  const config = useApi(configApiRef);
  const version = config.getOptionalString('app.version');
  const versionUrl = config.getOptionalString('app.versionUrl');

  if (!version || !versionUrl) {
    return null;
  }
  return (
    <SidebarItem
      icon={VersionIcon}
      to={versionUrl}
      text={version}
      target="_blank"
      rel="noopener noreferrer"
    />
  );
};
